function required(name: string): string {
  const value = process.env[name];
  if (value === undefined || value === "") {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
}

function optional(name: string): string {
  return process.env[name] ?? "";
}

function apiBaseUrl(urlKey: string, versionKey: string): string {
  const url = required(urlKey).replace(/\/$/, "");
  const version = required(versionKey).replace(/^\//, "");
  return `${url}/api/${version}`;
}

const env = {
  BACKEND_API_URL: apiBaseUrl(
    "REACT_APP_BACKEND_URL",
    "REACT_APP_BACKEND_VERSION"
  ),
  SSO_BACKEND_API_URL: apiBaseUrl(
    "REACT_APP_SSO_BACKEND_URL",
    "REACT_APP_SSO_BACKEND_VERSION"
  ),
  APP_VERSION: required("REACT_APP_VERSION"),
  /** Dominio del cookie di trasporto SSO (es. ".feinar.it"). Vuoto in dev = host-only. */
  COOKIE_DOMAIN: optional("REACT_APP_COOKIE_DOMAIN"),
};

export default env;
